// @flow
import React from 'react';
import type { Node } from 'react';

import PageContent from 'shared/layout/PageContent';
import MissedTargetIcon from 'shared/icons/MissedTargetIcon';
import Button from 'shared/components/Button';

import styles from './NotFound.module.scss';

const NotFound = (): Node => (
  <PageContent contentClassName={styles.content}>
    <MissedTargetIcon className={styles.icon} />
    <h1 className={styles.title}>Shoot, looks like a miss.</h1>
    <p className={styles.text}>
      We're sorry, the page you're trying to access doesn't exist or has moved.
    </p>
    <Button
      className={styles.button}
      url={`${String(process.env.REACT_APP_ACADEMY_APP_URL)}/search`}
    >
      Go to search
    </Button>
  </PageContent>
);

NotFound.displayName = 'NotFound';

export default NotFound;
